import React from "react";
import { Solicitud } from "./Solicitud";

export function WrapperSolicitudes({ user, solicitudesYRegistros, currentPage, prevHandler, nextHandler, paginasTotales, admin }) {
  return (
    <>
      {solicitudesYRegistros.length === 0 &&
        <div className="noExistenSolicitudes">
          No existen solicitudes
        </div>
      }
      {solicitudesYRegistros.length !== 0 &&
        <>
          <table>
            <thead>
              <tr>
                <th style={{width: "25%"}}>Nombre</th>
                <th>Email</th>
                <th className="anchoCeldaSolicitudes">Fecha</th>
                <th className="anchoCeldaSolicitudes"></th>
              </tr>
            </thead>
            <tbody>
              {solicitudesYRegistros.map((solicitudYRegistro) => (
                <Solicitud user={user} key={solicitudYRegistro.solicitud.datosTrabajador.id} solicitud={solicitudYRegistro.solicitud} registro={solicitudYRegistro.registro} admin={admin} />
              ))}
            </tbody>
          </table>
          <div className="navButtonsListWorkers">
            <button className="acceptButton" onClick={prevHandler}>Anterior</button>
            <span className="px-4">Pagina {currentPage} de {paginasTotales}</span>
            <button className="acceptButton" onClick={nextHandler}>Siguiente</button>
          </div>
        </>
      }
    </>
  );
}
